import { useState, useEffect } from 'react';
import { Laptop, Smartphone, Tablet } from 'lucide-react';

type DeviceType = 'desktop' | 'tablet' | 'mobile';

const DevicePreviewToggle = () => {
  const [activeDevice, setActiveDevice] = useState<DeviceType>('desktop');

  const applyDeviceWidth = (device: DeviceType) => {
    const root = document.documentElement;
    switch (device) {
      case 'mobile':
        root.style.width = '375px';
        root.style.margin = '0 auto';
        break;
      case 'tablet':
        root.style.width = '768px';
        root.style.margin = '0 auto';
        break;
      case 'desktop':
        root.style.width = '100%';
        root.style.margin = '0';
        break;
    }
  };

  useEffect(() => {
    applyDeviceWidth(activeDevice);
    return () => {
      document.documentElement.style.width = '100%';
      document.documentElement.style.margin = '0';
    };
  }, [activeDevice]);

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-black/20 backdrop-blur-sm shadow-lg rounded-full px-4 py-2 z-50 flex gap-4">
      <button
        onClick={() => setActiveDevice('desktop')}
        className={`p-2 rounded-full transition-colors ${
          activeDevice === 'desktop' ? 'bg-white/20 text-white' : 'text-white/70 hover:text-white hover:bg-white/10'
        }`}
        title="Desktop Ansicht"
      >
        <Laptop size={20} />
      </button>
      <button
        onClick={() => setActiveDevice('tablet')}
        className={`p-2 rounded-full transition-colors ${
          activeDevice === 'tablet' ? 'bg-white/20 text-white' : 'text-white/70 hover:text-white hover:bg-white/10'
        }`}
        title="Tablet Ansicht"
      >
        <Tablet size={20} />
      </button>
      <button
        onClick={() => setActiveDevice('mobile')}
        className={`p-2 rounded-full transition-colors ${
          activeDevice === 'mobile' ? 'bg-white/20 text-white' : 'text-white/70 hover:text-white hover:bg-white/10'
        }`}
        title="Mobile Ansicht"
      >
        <Smartphone size={20} />
      </button>
    </div>
  );
};

export default DevicePreviewToggle;